var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyTermsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22667_112732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 25L25 27L29.5 22.5M31.9012 17.9985C32.1071 18.4965 32.5024 18.8924 33.0001 19.0991L34.7452 19.822C35.2433 20.0283 35.639 20.424 35.8453 20.9221C36.0516 21.4201 36.0516 21.9797 35.8453 22.4778L35.1229 24.2218C34.9165 24.7201 34.9162 25.2803 35.1236 25.7783L35.8447 27.5218C35.9469 27.7685 35.9996 28.0329 35.9996 28.2999C35.9997 28.567 35.9471 28.8314 35.8449 29.0781C35.7427 29.3249 35.5929 29.549 35.4041 29.7378C35.2152 29.9266 34.991 30.0764 34.7443 30.1785L33.0004 30.9009C32.5023 31.1068 32.1065 31.5021 31.8998 31.9998L31.1769 33.745C30.9706 34.2431 30.575 34.6388 30.0769 34.8451C29.5789 35.0514 29.0193 35.0514 28.5212 34.8451L26.7773 34.1227C26.2792 33.9169 25.7198 33.9173 25.2221 34.1239L23.4769 34.8458C22.9791 35.0516 22.42 35.0514 21.9224 34.8453C21.4247 34.6391 21.0293 34.2439 20.8228 33.7464L20.0997 32.0006C19.8938 31.5026 19.4985 31.1067 19.0008 30.9L17.2557 30.1771C16.7578 29.9709 16.3623 29.5754 16.1559 29.0777C15.9495 28.5799 15.9492 28.0205 16.1551 27.5225L16.8775 25.7786C17.0833 25.2805 17.0828 24.7211 16.8763 24.2233L16.155 22.4768C16.0527 22.2301 16 21.9657 16 21.6986C16 21.4316 16.0525 21.1672 16.1547 20.9204C16.2569 20.6737 16.4067 20.4496 16.5956 20.2608C16.7844 20.072 17.0086 19.9222 17.2554 19.8201L18.9993 19.0977C19.4969 18.892 19.8925 18.4972 20.0993 18.0001L20.8222 16.2548C21.0285 15.7567 21.4242 15.361 21.9222 15.1547C22.4203 14.9484 22.9799 14.9484 23.4779 15.1547L25.2218 15.8771C25.7199 16.0829 26.2793 16.0825 26.7771 15.8759L28.523 15.1558C29.021 14.9497 29.5804 14.9497 30.0784 15.156C30.5763 15.3622 30.972 15.7578 31.1783 16.2558L31.9014 18.0015L31.9012 17.9985Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22667_112732",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22667_112732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22667_112732",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyTermsCheck);
export default __webpack_public_path__ + "static/media/loyalty-terms-check.d8a0a8c6f1b39d41d2ded408dc4ea2f7.svg";
export { ForwardRef as ReactComponent };